var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm.isShowingUpgrade
        ? _c(
            "site-link",
            {
              staticClass: "margin-right-md",
              attrs: { to: { name: "plans" } },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture("usage:plans_link_click")
                },
              },
            },
            [_vm._v("\n    Upgrade\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "kit"
        ? _c(
            "site-link",
            {
              attrs: {
                to: _vm.$docs("/web/setup/use-kit", {
                  hash: "#tune-your-kits",
                }),
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture("usage:tune_your_kits_link_click")
                },
              },
            },
            [_vm._v("\n    How to Tune Your Kits\n  ")]
          )
        : _vm.type === "npm"
        ? _c(
            "site-link",
            {
              attrs: {
                to: _vm.$docs("/web/dig-deeper/continuous-integration"),
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture("usage:tune_your_ci_link_click")
                },
              },
            },
            [_vm._v("\n    How to Tune Your CI\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }